import React from 'react'

import TextInput from "components/textInput"
import TextArea from "components/textArea"
import Checkboxes from 'components/checkboxes'
import Radiobuttons from 'components/radiobuttons'
import ServiceSelector from 'components/formFields/serviceSelector'
import Select from 'components/formFields/select'
import FileUpload from 'components/formFields/fileUpload'
  
export default ({
    column, 
    values, 
    handleChange,
    showRequiredAsterisk
}) => {
    let Component = null 

    const {
        type,
        label,
        subtitle
    } = column

    switch(type) {
        case 'text':
        case 'email':
            Component = TextInput
            break;
        case 'textarea':
            Component = TextArea
            break
        case 'checkboxes':
        case 'radios':
            Component = Checkboxes
            break
        case 'radioboxes':
            Component = Radiobuttons
            break
        case 'serviceSelector':
            Component = ServiceSelector
            break
        case 'recipientSelector':
            Component = Select
            break
        case 'file':
            Component = FileUpload
            break
    }

    if(!Component){
        return null
    }

    const inputKey = label

    const integratedKey = 'Interested in integrated solutions?'

    return (
        <div>
            <label>
                { label }
                { showRequiredAsterisk && column.required ?
                    <sup>*</sup>
                : null }
            </label>
            { subtitle &&
                <span className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle}} />
            }
            <Component 
                {...column}
                inputKey={inputKey} 
                handleChange={value => handleChange(inputKey, value)}
                handleChangeIntegrated={value => handleChange(integratedKey, value)}
                integratedValue={values[integratedKey] || 'Yes'}
                value={values[inputKey] || undefined}
            />
        </div>
    )
}